import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface WarningCircleIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const WarningCircleIcon = ({ className, ...props }: WarningCircleIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM11.4521 16.4971C11.7292 16.1892 12.2038 16.1643 12.5117 16.4414C12.8196 16.7185 12.8445 17.1931 12.5674 17.501L12.5576 17.5117C12.2805 17.8196 11.8059 17.8445 11.498 17.5674C11.1903 17.2903 11.1653 16.8156 11.4424 16.5078L11.4521 16.4971ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V7C11.25 6.58579 11.5858 6.25 12 6.25Z"
      fill="currentColor"
    />
  </svg>
);

export default WarningCircleIcon;
